import { render, staticRenderFns } from "./AppreciationService.vue?vue&type=template&id=3667f23a&scoped=true&"
import script from "./AppreciationService.vue?vue&type=script&lang=js&"
export * from "./AppreciationService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667f23a",
  null
  
)

export default component.exports